// extracted by mini-css-extract-plugin
module.exports = {"root":"BoxedWarning_root__17c4g","paragraph":"BoxedWarning_paragraph__oWHXA"};